import { Option } from "api/common/types/common.types";
import { FeatureData } from "components/Forms/components/sections/TestedFeaturesSection/TestedFeaturesSection";

import { PcmFileMetadata } from "./PcmFileUploadSection";

/**
 * Default values for the PCM form - used by withForm for type inference.
 * Actual runtime values come from the parent form instance.
 */
export const pcmFormDefaultValues = {
  isMaintenance: false,
  scheme: { label: "", value: "" },
  ccProduct: { label: "", value: "" },
  ccMaintenance: { label: "", value: 0 },
  ccLab: { label: "", value: 0 },
  phone1: "",
  custemail: "",
  custuname: "",
  vendor: "",
  protectionProfiles: [] as Option[],
  fileType: "",
  fileLabel: "",
  files: [] as PcmFileMetadata[],
  additionalInformation: "",
  testedFeatures: [] as FeatureData[],
  // Edit mode fields
  deadline: "",
  update: "",
  send_response: false,
};
